import React, { useEffect, useState } from "react"; 
import ColisAdmDetails from "../../../ui/layouts/ColisAdmDetails";
import UserStorage from "../../../services/UserStorage";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { editColisInfo, getColisByCodeAdm } from "../../../slices/ColisAdm";

const ColisAdmDetailsContainer = ({ show, onClose, sel_colis, load_data }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { loading, error } = useSelector((state) => state.colis);
  const [colis, set_colis] = useState(null);

  const load_colis = () => {
    dispatch(getColisByCodeAdm(sel_colis?.code))
      .unwrap()
      .then((res) => {
        set_colis(res);
      })
      .catch((err) => console.log(err));
  };

  const onPrint = () => {
    if (colis) {
        UserStorage.setParam([colis])
        const win = window.open("/dashb/colis/print/", "_blank");
        win.focus();
    }
  };

  const onEditField = (field , value) => {
    dispatch(editColisInfo({id : colis?.ref , field : field , f_data : value })).unwrap().then(d =>  {
        load_colis()
        load_data()
    });
}

  useEffect(() => {
    load_colis();
  }, [sel_colis]);

  return (
    <>
      <ColisAdmDetails data={colis} isShow={show} onHide={onClose} onPrint={onPrint}  onEditField={onEditField} loading={loading} />
    </>
  );
};

export default ColisAdmDetailsContainer;
